 
import $ from 'jquery';
import ko from 'knockout';
import EmailSignupViewModel from './viewmodels/emailsignupviewmodel';
import { getFormData } from './emailsignupdata';
import { HTTP_STATUS_OK, HTTP_STATUS_NOCONTENT } from '../../smartpak/httpstatus';
import { isDynamicFormValid } from '../../validation/unobtrusivehelpers';
import { parseQueryString } from '../../smartpak/url';
import captureEmailLeadEvent from './captureemaillead';

function onDocReady() {
    const $container = document.getElementById('email-sign-up-form'),
        parameters = parseQueryString(location.search),
        source = parameters.from === 'catalog' ? 'CatalogRequest' : '',
        email = parameters.email || smartPak?.cdProfileCookie?.CustomerEmail || '';

    if ($container) {
        const $form = $container.querySelector('form'),
            $success = document.getElementById('email-sign-up-success');

        $success.style.display = 'none';

        if ($form && $success) {
            getFormData().then(response => {
                if (response.status === HTTP_STATUS_OK) {
                    const emailSignupViewModel = new EmailSignupViewModel(response.content, email, source);

                    if ($container) {
                        ko.applyBindings(emailSignupViewModel, $container);

                        $form.addEventListener('submit', e => {
                            e.preventDefault();
                            if (isDynamicFormValid($($form))) {
                                emailSignupViewModel.save().then(response => {
                                    if (response.Status === HTTP_STATUS_NOCONTENT) {
                                        $form.style.display = 'none';
                                        $success.style.display = 'block';
                                    }

                                    captureEmailLeadEvent();
                                });
                            }
                        });
                    }
                }
            });
        }
    }
}

if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
    onDocReady();
} else {
    window.addEventListener('DOMContentLoaded', onDocReady);
}
